"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.tsx
var src_exports = {};
__export(src_exports, {
  Accordion: () => Accordion_default,
  AdvisorTabs: () => AdvisorTabs_default,
  AutoCloser: () => AutoCloser_default,
  BackButton: () => BackButton_default,
  Button: () => Button_default,
  Checkbox: () => Checkbox_default,
  CheckboxGroup: () => CheckboxGroup_default,
  DEFAULT_NO_SELECTION_ID: () => DEFAULT_NO_SELECTION_ID,
  DatePicker: () => DatePicker_default,
  Dialog: () => Dialog_default,
  Drawer: () => Drawer_default,
  EulaFormattedText: () => EulaFormattedText_default,
  ExclamationCircle: () => ExclamationCircle_default,
  Icon: () => Icon_exports,
  InputLabel: () => InputLabel_default,
  MGPIFrame: () => MGPIFrame_default,
  Markup: () => Markup_default,
  Radio: () => Radio_default,
  RadioGroup: () => RadioGroup_default,
  SelectBox: () => SelectBox_default,
  Stepper: () => Stepper_default,
  Table: () => Table,
  TableFilters: () => TableFilters_default,
  Tabs: () => Tabs_default,
  TextArea: () => TextArea_default,
  TextInput: () => TextInput_default,
  ToggleButton: () => ToggleButton_default,
  Tooltip: () => Tooltip_default,
  Typography: () => Typography_default,
  formatCurrency: () => formatCurrency,
  useIsSafari: () => useIsSafari,
  useTabControls: () => useTabControls,
  useTableFilters: () => useTableFilters
});
module.exports = __toCommonJS(src_exports);

// src/components/Button/Button.tsx
var React2 = __toESM(require("react"));

// src/hooks.ts
var React = __toESM(require("react"));
var import_classnames = __toESM(require("classnames"));
var useTypographyAttributes = ({
  variant,
  weight,
  fontFamily,
  gutterBottom,
  color,
  darkColor,
  align,
  className
}) => {
  return {
    className: React.useMemo(() => {
      return (0, import_classnames.default)(
        "typography",
        {
          "typography-display": variant === "display",
          "typography-title-2xl": variant === "title-2xl",
          "typography-title-xl": variant === "title-xl",
          "typography-title-lg": variant === "title-lg",
          "typography-title-md": variant === "title-md",
          "typography-title-sm": variant === "title-sm",
          "typography-title-xs": variant === "title-xs",
          "typography-body-2xl": variant === "body-2xl",
          "typography-title-3xl": variant === "title-3xl",
          "typography-body-xl": variant === "body-xl",
          "typography-body-lg": variant === "body-lg",
          "typography-body-md": variant === "body",
          "typography-body-sm": variant === "body-sm",
          "typography-body-xs": variant === "body-xs"
        },
        gutterBottom ? {
          "typography-gutter-lg": variant === "title-lg" || variant === "body",
          "typography-gutter-sm": variant === "title-md" || variant === "title-sm" || variant === "title-xs" || variant === "body-xs",
          "typography-gutter-md": variant === "body-sm"
        } : {},
        {
          "typography-thin": weight === "thin",
          "typography-normal": weight === "normal",
          "typography-medium": weight === "medium",
          "typography-semibold": weight === "semibold"
        },
        {
          "typography-font-sans": fontFamily === "sans",
          "typography-font-serif": fontFamily === "serif",
          "typography-font-italic": fontFamily === "italic",
          "typography-font-mono": fontFamily === "mono"
        },
        {
          "typography-text-inherit": color === "inherit",
          "typography-text-primary": color === "primary",
          "typography-text-secondary": color === "secondary",
          "typography-text-secondary-gray": color === "secondary-gray",
          "typography-text-tertiary": color === "tertiary",
          "typography-text-quaternary": color === "quaternary",
          "typography-text-accent": color === "accent",
          "typography-text-light": color === "light",
          "typography-text-link": color === "link",
          "typography-text-disabled": color === "disabled",
          "typography-text-danger": color === "danger",
          "typography-text-black": color === "black"
        },
        {
          "dark:typography-text-inherit": darkColor === "inherit",
          "dark:typography-text-primary": darkColor === "primary",
          "dark:typography-text-secondary": darkColor === "secondary",
          "dark:typography-text-secondary-gray": darkColor === "secondary-gray",
          "dark:typography-text-tertiary": darkColor === "tertiary",
          "dark:typography-text-quaternary": darkColor === "quaternary",
          "dark:typography-text-accent": darkColor === "accent",
          "dark:typography-text-light": darkColor === "light",
          "dark:typography-text-link": darkColor === "link",
          "dark:typography-text-disabled": darkColor === "disabled",
          "dark:typography-text-danger": darkColor === "danger",
          "dark:typography-text-black": darkColor === "black"
        },
        {
          "typography-text-align-inherit": align === "inherit",
          "typography-text-align-center": align === "center",
          "typography-text-align-justify": align === "justify",
          "typography-text-align-left": align === "left",
          "typography-text-align-right": align === "right"
        },
        className
      );
    }, [
      variant,
      fontFamily,
      weight,
      gutterBottom,
      color,
      align,
      className,
      darkColor
    ])
  };
};
var useButtonAttributes = ({
  size,
  variant,
  fullWidth,
  href,
  className
}) => {
  const BaseComponent = React.useMemo(() => href ? "a" : "button", [href]);
  const computedClassName = React.useMemo(() => {
    return (0, import_classnames.default)(
      "button",
      "button-text",
      {
        "button-sm button-text-sm": size === "sm",
        "button-md button-text-md": size === "md",
        "button-lg button-text-lg": size === "lg"
      },
      {
        "button-primary button-primary-text": variant === "primary",
        "button-primary-dark button-primary-dark-text": variant === "primary-dark",
        "button-secondary button-secondary-text": variant === "secondary",
        "button-secondary-dark button-secondary-dark-text": variant === "secondary-dark",
        "button-tertiary button-tertiary-text": variant === "tertiary",
        "button-tertiary-dark button-tertiary-dark-text": variant === "tertiary-dark",
        "button-danger button-danger-text": variant === "danger",
        "button-danger-secondary button-danger-secondary-text": variant === "danger-secondary",
        "button-disabled button-disabled-text": variant === "disabled"
      },
      {
        "w-full": fullWidth === true
      },
      className
    );
  }, [variant, size, fullWidth, className]);
  return { BaseComponent, className: computedClassName };
};
var useTextInputAttributes = ({
  error,
  type
}) => {
  const className = React.useMemo(() => {
    return (0, import_classnames.default)("TextFieldInput", {
      "TextFieldInput--error": !!error,
      "TextFieldInput--with-icon": type === "currency"
      // for now currency is the only type with an icon to display
    });
  }, [error, type]);
  return {
    className
  };
};
var useTextAreaAttributes = ({
  error
}) => {
  const className = React.useMemo(() => {
    return (0, import_classnames.default)("TextAreaInput", {
      "TextAreaInput--error": !!error
    });
  }, [error]);
  return {
    className
  };
};
var useTabControls = (config) => {
  const [activeTabId, setActiveTabId] = React.useState(
    config.defaultActiveTabId || config.tabs[0].id
  );
  const activeTab = React.useMemo(
    () => config.tabs.find(({ id }) => id === activeTabId) || config.tabs.find(
      ({ id }) => id === config.defaultActiveTabId
    ) || config.tabs[0],
    [activeTabId, config]
  );
  return {
    activeTab,
    setActiveTabId,
    tabs: config.tabs
  };
};
var useSelectBoxSearchInputControls = () => {
  const [keyword, setKeyword] = React.useState("");
  return {
    keyword,
    setKeyword
  };
};
var useIsSafari = () => {
  const [isSafari, setIsSafari] = React.useState(false);
  React.useEffect(() => {
    if (navigator) {
      setIsSafari(
        !!navigator.vendor && navigator.vendor.indexOf("Apple") > -1 && !!navigator.userAgent && navigator.userAgent.indexOf("CriOS") == -1 && navigator.userAgent.indexOf("FxiOS") == -1
      );
    }
  }, [isSafari, setIsSafari]);
  return isSafari;
};
var useTableFilters = ({
  initialFilters
}) => {
  const [filters, setFilters] = React.useState(initialFilters);
  const activeFilters = React.useMemo(
    () => filters.reduce((acc, filterCategory) => {
      const activeValues = filterCategory.filters.filter((filter) => filter.active).map((filter) => filter.value);
      if (activeValues.length > 0) {
        acc[filterCategory.key] = activeValues;
      }
      return acc;
    }, {}),
    [filters]
  );
  const clearFilters = React.useCallback(() => {
    setFilters(initialFilters);
  }, [initialFilters]);
  return { filters, setFilters, activeFilters, clearFilters };
};

// src/components/Button/Button.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Button = ({
  size = "md",
  disabled = false,
  fullWidth = false,
  href,
  variant,
  children,
  className,
  ...attrs
}, ref) => {
  const { className: computedClassName, BaseComponent } = useButtonAttributes({
    size,
    variant,
    href,
    fullWidth,
    className
  });
  const ButtonBase = BaseComponent;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    ButtonBase,
    {
      ref,
      ...attrs,
      href,
      disabled,
      className: computedClassName,
      children
    }
  );
};
var Button_default = React2.forwardRef(Button);

// src/components/Typography/Typography.tsx
var React3 = __toESM(require("react"));
var import_jsx_runtime2 = require("react/jsx-runtime");
var URL_REGEX = /(https?:\/\/[^\s]+)/g;
var isSafeUrl = (url) => {
  try {
    const urlObj = new URL(url);
    return urlObj.protocol === "http:" || urlObj.protocol === "https:";
  } catch {
    return false;
  }
};
var parseTextWithLinks = (text) => {
  if (typeof text !== "string") {
    return text;
  }
  const parts = text.split(URL_REGEX);
  return parts.map((part, index) => {
    if (part.match(URL_REGEX) && isSafeUrl(part)) {
      return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
        "a",
        {
          href: part,
          target: "_blank",
          rel: "noopener noreferrer",
          className: "underline hover:opacity-80",
          children: part
        },
        index
      );
    }
    return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(React3.Fragment, { children: part }, index);
  });
};
var TypographyRoot = React3.forwardRef(
  ({ as, ...attrs }, ref) => {
    switch (as) {
      case "h1":
        return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("h1", { ...attrs, ref });
      case "h2":
        return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("h2", { ...attrs, ref });
      case "h3":
        return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("h3", { ...attrs, ref });
      case "h4":
        return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("h4", { ...attrs, ref });
      case "h5":
        return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("h5", { ...attrs, ref });
      case "h6":
        return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("h6", { ...attrs, ref });
      case "span":
        return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("span", { ...attrs, ref });
      default:
        return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("p", { ...attrs, ref });
    }
  }
);
var Typography = ({
  color = "inherit",
  darkColor,
  fontFamily = "sans",
  variant,
  weight = "normal",
  gutterBottom = false,
  component,
  align = "inherit",
  className,
  children,
  ...props
}, ref) => {
  const { className: computedClassName } = useTypographyAttributes({
    color,
    fontFamily,
    variant,
    weight,
    gutterBottom,
    align,
    darkColor,
    className
  });
  const variantMapping = {
    "display": "h1",
    "title-2xl": "h1",
    "title-xl": "h1",
    "title-lg": "h1",
    "title-md": "h2",
    "title-sm": "h3",
    "title-xs": "h4",
    "body-xs": "span"
  };
  const parsedChildren = React3.useMemo(() => {
    if (typeof children === "string") {
      return parseTextWithLinks(children);
    }
    return children;
  }, [children]);
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    TypographyRoot,
    {
      ref,
      as: component || variantMapping[variant] || "p",
      className: computedClassName,
      ...props,
      children: parsedChildren
    }
  );
};
var Typography_default = React3.forwardRef(Typography);

// src/components/TextInput/TextInput.tsx
var React5 = __toESM(require("react"));
var import_classnames3 = __toESM(require("classnames"));
var import_react_input_mask = __toESM(require("@mona-health/react-input-mask"));

// src/helpers.ts
var import_classnames2 = __toESM(require("classnames"));
var getIconColorClassName = (color) => (0, import_classnames2.default)({
  "stroke-black": color === "black",
  "stroke-white": color === "white",
  "stroke-green-1": color === "green-1",
  "stroke-green-2": color === "green-2",
  "stroke-green-3": color === "green-3",
  "stroke-green-4": color === "green-4",
  "stroke-green-5": color === "green-5",
  "stroke-yellow-1": color === "yellow-1",
  "stroke-yellow-2": color === "yellow-2",
  "stroke-yellow-3": color === "yellow-3",
  "stroke-blue-1": color === "blue-1",
  "stroke-blue-2": color === "blue-2",
  "stroke-blue-3": color === "blue-3",
  "stroke-teal-1": color === "teal-1",
  "stroke-teal-2": color === "teal-2",
  "stroke-teal-3": color === "teal-3",
  "stroke-danger": color === "danger",
  "stroke-link": color === "link",
  "stroke-inherit": color === "inherit"
});
var formatCurrency = (value) => {
  if (!value)
    return "";
  const numericValue = parseFloat(value.replace(/[^\d.]/g, ""));
  if (isNaN(numericValue))
    return "";
  const formattedValue = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0
  }).format(numericValue);
  return formattedValue.replace("$", "");
};

// src/components/Icon/ExclamationCircle.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var SvgComponent = (props) => /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ...props,
    children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
      "path",
      {
        stroke: "#C64E39",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M8 5.333V8m0 2.667h.007M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0Z"
      }
    )
  }
);
var ExclamationCircle_default = SvgComponent;

// src/components/InputLabel/InputLabel.tsx
var React4 = __toESM(require("react"));
var import_jsx_runtime4 = require("react/jsx-runtime");
var InputLabel = ({
  label,
  required,
  showOptional
}) => {
  const requiredStatus = React4.useMemo(
    () => required ? /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("span", { className: "InputLabel--required", children: "*" }) : "",
    [required]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)("label", { className: "InputLabel", children: [
    label,
    requiredStatus,
    !requiredStatus && showOptional ? /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(Typography_default, { variant: "body", color: "secondary", className: "ml-2", children: "optional" }) : null
  ] });
};
var InputLabel_default = InputLabel;

// src/components/TextInput/TextInput.tsx
var import_jsx_runtime5 = require("react/jsx-runtime");
var TextInput = ({
  label,
  error,
  required,
  helperText,
  maskOptions,
  type = "text",
  tooltip,
  helperTextPosition = "bottom",
  secureText,
  showOptional = false,
  showError = true,
  ...props
}, ref) => {
  const { className } = useTextInputAttributes({
    label,
    error,
    required,
    type
  });
  const inputErrorLabelClassName = React5.useMemo(
    () => (0, import_classnames3.default)("TextFieldErrorLabel", { "TextFieldErrorLabel--visible": !!error }),
    [error]
  );
  const helperTextClassName = React5.useMemo(
    () => (0, import_classnames3.default)("TextFieldHelperText", {
      "TextFieldHelperText--visible": !!helperText,
      "TextFieldHelperText--top": helperTextPosition === "top"
    }),
    [helperText, helperTextPosition]
  );
  const icon = React5.useMemo(() => {
    switch (type) {
      case "currency":
        return "$";
      default:
        return "";
    }
  }, [type]);
  const inputType = React5.useMemo(() => {
    switch (type) {
      case "number":
        return "number";
      case "password":
        return "password";
      default:
        return "text";
    }
  }, [type]);
  const [displayValue, setDisplayValue] = React5.useState("");
  const handleChange = (event) => {
    try {
      if (props.onChange) {
        props.onChange(event);
      }
      if (type === "currency") {
        const value = event.target.value;
        const formattedValue = formatCurrency(value);
        setDisplayValue(formattedValue);
      }
    } catch (error2) {
      console.error(error2);
    }
  };
  const inputClassName = React5.useMemo(
    () => (0, import_classnames3.default)(className, { "TextFieldInput--secure": secureText }),
    [className, secureText]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)("div", { className: (0, import_classnames3.default)("TextField", { "--with-error": showError }), children: [
    /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)("div", { className: "TextFieldLabelTooltipContainer", children: [
      /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
        InputLabel_default,
        {
          label,
          required,
          showOptional
        }
      ),
      helperText && helperTextPosition === "top" && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("span", { className: helperTextClassName, children: helperText }),
      tooltip && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(import_jsx_runtime5.Fragment, { children: tooltip })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)("div", { className: "relative", children: [
      icon && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("span", { className: "TextFieldInputIcon", children: icon }),
      maskOptions ? /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
        import_react_input_mask.default,
        {
          ref,
          ...maskOptions,
          ...props,
          type: "text",
          className,
          onChange: props.onChange,
          children: /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("input", { className })
        }
      ) : /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
        "input",
        {
          ...props,
          ref,
          type: inputType,
          className: inputClassName,
          value: type === "currency" && displayValue ? displayValue : props.value,
          onChange: handleChange
        }
      )
    ] }),
    helperText && helperTextPosition === "bottom" && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("span", { className: helperTextClassName, children: helperText }),
    error && /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)("span", { className: inputErrorLabelClassName, children: [
      /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(ExclamationCircle_default, {}),
      error
    ] })
  ] });
};
var TextInput_default = React5.forwardRef(TextInput);

// src/components/SelectBox/SelectBox.tsx
var React6 = __toESM(require("react"));

// src/components/Icon/index.tsx
var Icon_exports = {};
__export(Icon_exports, {
  Check: () => Check_default,
  CheckOutline: () => CheckOutline_default,
  ChevronDown: () => ChevronDown_default,
  ChevronLeft: () => ChevronLeft_default,
  ChevronRight: () => ChevronRight_default,
  ChevronUp: () => ChevronUp_default,
  Cross: () => Cross_default,
  ExclamationCircle: () => ExclamationCircle_default,
  Minus: () => Minus_default,
  Plus: () => Plus_default
});

// src/components/Icon/ChevronDown.tsx
var import_jsx_runtime6 = require("react/jsx-runtime");
var ChevronDown = ({ color = "black", size = 24 }) => {
  const className = getIconColorClassName(color);
  return /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("svg", { className, width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("path", { d: "M18 9.5L12 15.5L6 9.5", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) });
};
var ChevronDown_default = ChevronDown;

// src/components/Icon/ChevronRight.tsx
var import_jsx_runtime7 = require("react/jsx-runtime");
var ChevronRight = ({ color = "black", size = 24 }) => {
  const className = getIconColorClassName(color);
  return /* @__PURE__ */ (0, import_jsx_runtime7.jsx)("svg", { className, width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ (0, import_jsx_runtime7.jsx)("path", { id: "Icon", d: "M10 7L15 12L10 17", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }) });
};
var ChevronRight_default = ChevronRight;

// src/components/Icon/ChevronUp.tsx
var import_jsx_runtime8 = require("react/jsx-runtime");
var ChevronUp = ({ color = "black", size = 24 }) => {
  const className = getIconColorClassName(color);
  return /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("svg", { className, width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("path", { d: "M6 14.5L12 8.5L18 14.5", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) });
};
var ChevronUp_default = ChevronUp;

// src/components/Icon/ChevronLeft.tsx
var import_jsx_runtime9 = require("react/jsx-runtime");
var ChevronLeft = ({ color = "black", size = 24 }) => {
  const className = getIconColorClassName(color);
  return /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("svg", { className, width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("path", { d: "M14 17L9 12L14 7", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) });
};
var ChevronLeft_default = ChevronLeft;

// src/components/Icon/Plus.tsx
var import_jsx_runtime10 = require("react/jsx-runtime");
var Plus = ({ color = "black", size = 24 }) => {
  const className = getIconColorClassName(color);
  return /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("svg", { className, width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("path", { d: "M12 6V12M12 12V18M12 12H18M12 12L6 12", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) });
};
var Plus_default = Plus;

// src/components/Icon/Minus.tsx
var import_jsx_runtime11 = require("react/jsx-runtime");
var Minus = ({ color = "black", size = 24 }) => {
  const className = getIconColorClassName(color);
  return /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("svg", { className, width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("path", { d: "M18 12H6", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) });
};
var Minus_default = Minus;

// src/components/Icon/Check.tsx
var import_jsx_runtime12 = require("react/jsx-runtime");
var Check = ({ color = "black", size = 24 }) => {
  const className = getIconColorClassName(color);
  return /* @__PURE__ */ (0, import_jsx_runtime12.jsx)("svg", { className, width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ (0, import_jsx_runtime12.jsx)("path", { d: "M5 13L9 17L19 7", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) });
};
var Check_default = Check;

// src/components/Icon/Cross.tsx
var import_jsx_runtime13 = require("react/jsx-runtime");
var Cross = ({ color = "black", size = 24 }) => {
  const className = getIconColorClassName(color);
  return /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("svg", { className, width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("path", { d: "M6 18L18 6M6 6L18 18", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) });
};
var Cross_default = Cross;

// src/components/Icon/CheckOutline.tsx
var import_jsx_runtime14 = require("react/jsx-runtime");
var CheckOutline = ({ color = "black", size = 24 }) => {
  const className = getIconColorClassName(color);
  return /* @__PURE__ */ (0, import_jsx_runtime14.jsx)("svg", { className, fill: "none", width: size, height: size, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ (0, import_jsx_runtime14.jsx)("path", { d: "M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) });
};
var CheckOutline_default = CheckOutline;

// src/components/SelectBox/SelectBox.tsx
var import_classnames4 = __toESM(require("classnames"));
var import_react = require("@headlessui/react");

// src/constants.ts
var DEFAULT_NO_SELECTION_ID = "NO_SELECTION";

// src/components/SelectBox/SelectBox.tsx
var import_jsx_runtime15 = require("react/jsx-runtime");
var SelectBox = React6.forwardRef(
  ({
    selected,
    options,
    disabled,
    label,
    error,
    required,
    noSelectionId = DEFAULT_NO_SELECTION_ID,
    noSelectionOptionLabel,
    onChange,
    autoComplete,
    showOptional = false,
    showError = true
  }, ref) => {
    const selectBoxButtonClassName = React6.useMemo(
      () => (0, import_classnames4.default)("SelectBoxButton", {
        "--error": !!error
      }),
      [error]
    );
    const selectBoxErrorLabelClassName = React6.useMemo(
      () => (0, import_classnames4.default)("SelectBoxErrorLabel", { "--visible": !!error }),
      [error]
    );
    const selectBoxSearchInputClassName = React6.useMemo(
      () => (0, import_classnames4.default)("SelectBoxSearchInput", {
        "--no-selection": (selected == null ? void 0 : selected.id) === noSelectionId
      }),
      [selected, noSelectionId]
    );
    const { keyword, setKeyword } = useSelectBoxSearchInputControls();
    return /* @__PURE__ */ (0, import_jsx_runtime15.jsxs)(
      "div",
      {
        "data-testid": "select-box",
        className: (0, import_classnames4.default)("SelectBox", { "--with-error": showError }),
        children: [
          label && /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
            InputLabel_default,
            {
              label,
              required,
              showOptional
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime15.jsxs)(
            import_react.Combobox,
            {
              ref,
              as: "div",
              value: selected,
              by: "id",
              onChange,
              disabled,
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime15.jsxs)(import_react.Combobox.Button, { className: selectBoxButtonClassName, children: [
                  /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
                    import_react.Combobox.Input,
                    {
                      className: selectBoxSearchInputClassName,
                      onChange: (e) => setKeyword(e.target.value),
                      displayValue: (opt) => opt.label,
                      autoComplete
                    }
                  ),
                  /* @__PURE__ */ (0, import_jsx_runtime15.jsx)("div", { children: /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(ChevronDown_default, {}) })
                ] }),
                /* @__PURE__ */ (0, import_jsx_runtime15.jsx)("div", { className: "SelectBoxOptionsPanelAnchor", children: /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(import_react.Combobox.Options, { className: "SelectBoxOptionsPanel", children: options.filter((opt) => {
                  if (keyword) {
                    const matchesValue = typeof opt.value === "string" && opt.value.toLowerCase().includes(keyword.toLowerCase());
                    const matchesLabel = opt.label.toLowerCase().includes(keyword.toLowerCase());
                    return matchesLabel || matchesValue;
                  }
                  return opt;
                }).map((opt) => /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
                  import_react.Combobox.Option,
                  {
                    value: opt,
                    disabled: opt.disabled,
                    children: ({ active, disabled: disabled2, selected: selected2 }) => /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
                      "div",
                      {
                        className: (0, import_classnames4.default)("SelectBoxOption", {
                          "--disabled": disabled2,
                          "--active": active,
                          "--selected": selected2
                        }),
                        children: /* @__PURE__ */ (0, import_jsx_runtime15.jsx)("div", { className: "SelectBoxOptionLabel", children: opt.id === noSelectionId ? noSelectionOptionLabel || "Select an option" : opt.label })
                      }
                    )
                  },
                  opt.id
                )) }) })
              ]
            }
          ),
          error && showError && /* @__PURE__ */ (0, import_jsx_runtime15.jsxs)("span", { className: selectBoxErrorLabelClassName, children: [
            /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(ExclamationCircle_default, {}),
            error
          ] })
        ]
      }
    );
  }
);
var SelectBox_default = SelectBox;

// src/components/Checkbox/Checkbox.tsx
var React8 = __toESM(require("react"));
var import_classnames6 = __toESM(require("classnames"));

// src/components/CheckboxGroup/CheckboxGroup.tsx
var React7 = __toESM(require("react"));
var import_classnames5 = __toESM(require("classnames"));

// src/components/CheckboxGroup/CheckboxGroupContext.ts
var import_react2 = require("react");
var CheckboxGroupContext = (0, import_react2.createContext)(false);

// src/components/CheckboxGroup/CheckboxGroup.tsx
var import_jsx_runtime16 = require("react/jsx-runtime");
var CheckboxGroup = React7.forwardRef(
  ({ children, name, onChange, error }, ref) => {
    const checkboxGroupErrorLabelClassName = React7.useMemo(
      () => (0, import_classnames5.default)("CheckboxGroupErrorLabel", {
        "CheckboxGroupErrorLabel--visible": !!error
      }),
      [error]
    );
    return /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(CheckboxGroupContext.Provider, { value: true, children: /* @__PURE__ */ (0, import_jsx_runtime16.jsxs)("span", { className: "CheckboxGroup-root", "data-testid": "checkbox-group", children: [
      React7.Children.map(
        children,
        (child) => {
          if (React7.isValidElement(child)) {
            return React7.cloneElement(child, {
              name,
              onChange,
              ref
            });
          }
          return child;
        }
      ),
      error && /* @__PURE__ */ (0, import_jsx_runtime16.jsxs)("span", { className: checkboxGroupErrorLabelClassName, children: [
        /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(ExclamationCircle_default, {}),
        error
      ] })
    ] }) });
  }
);
var CheckboxGroup_default = CheckboxGroup;

// src/components/Checkbox/Checkbox.tsx
var import_jsx_runtime17 = require("react/jsx-runtime");
var Checkbox = React8.forwardRef(
  ({ label, checked, disabled, error, className, ...attrs }, ref) => {
    const labelTextClassName = React8.useMemo(
      () => (0, import_classnames6.default)("CheckboxLabelText", { "--disabled": disabled }),
      [disabled]
    );
    const checkboxErrorLabelClassName = React8.useMemo(
      () => (0, import_classnames6.default)("CheckboxErrorLabel", { "CheckboxErrorLabel--visible": !!error }),
      [error]
    );
    const isInGroup = React8.useContext(CheckboxGroupContext);
    return /* @__PURE__ */ (0, import_jsx_runtime17.jsxs)(
      "div",
      {
        className: (0, import_classnames6.default)(
          "Checkbox",
          { "Checkbox--in-group": isInGroup },
          className
        ),
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime17.jsxs)("label", { className: "CheckboxLabel", htmlFor: attrs.id, children: [
            /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(
              "input",
              {
                className: "CheckboxInput",
                ref,
                type: "checkbox",
                checked,
                disabled,
                ...attrs
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime17.jsx)("span", { className: labelTextClassName, children: label })
          ] }),
          /* @__PURE__ */ (0, import_jsx_runtime17.jsxs)("span", { className: checkboxErrorLabelClassName, children: [
            error && /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(ExclamationCircle_default, {}),
            error
          ] })
        ]
      }
    );
  }
);
var Checkbox_default = Checkbox;

// src/components/Drawer/Drawer.tsx
var import_react3 = require("@headlessui/react");
var import_jsx_runtime18 = require("react/jsx-runtime");
var Drawer = ({
  children,
  renderHeader,
  renderTitle,
  defaultOpen = false
}) => {
  if (!renderTitle && !renderHeader)
    throw Error(
      `Missing props: 'renderHeader' or 'renderTitle' is required on <Drawer> component.`
    );
  return /* @__PURE__ */ (0, import_jsx_runtime18.jsxs)(
    import_react3.Disclosure,
    {
      "data-testid": "drawer",
      as: "div",
      className: "Drawer",
      defaultOpen,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(import_react3.Disclosure.Button, { className: "w-full", children: ({ open }) => renderTitle ? /* @__PURE__ */ (0, import_jsx_runtime18.jsxs)("div", { className: "DrawerHeading", children: [
          renderTitle(open),
          /* @__PURE__ */ (0, import_jsx_runtime18.jsx)("div", { className: "DrawerIcon", children: /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(ChevronDown_default, { size: 24, color: "inherit" }) })
        ] }) : renderHeader ? renderHeader(open) : /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(import_jsx_runtime18.Fragment, {}) }),
        /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(
          import_react3.Transition,
          {
            enter: "transition-opacity duration-300",
            enterFrom: "opacity-0",
            enterTo: "opacity-100",
            unmount: false,
            children: /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(import_react3.Disclosure.Panel, { className: "DrawerPanel", unmount: false, children })
          }
        )
      ]
    }
  );
};
var Drawer_default = Drawer;

// src/components/Radio/Radio.tsx
var React9 = __toESM(require("react"));
var import_classnames7 = __toESM(require("classnames"));
var import_jsx_runtime19 = require("react/jsx-runtime");
var Radio = React9.forwardRef(
  ({ value, label, name, disabled, error, checked, onChange, helperText }, ref) => {
    const textLabel = label ?? value;
    const inputId = `${name}-${textLabel}-${value}`;
    const inputClassName = (0, import_classnames7.default)("Radio-input", { "Radio-input--error": !!error });
    return /* @__PURE__ */ (0, import_jsx_runtime19.jsxs)("div", { className: "Radio-root", "data-testid": "radio", children: [
      /* @__PURE__ */ (0, import_jsx_runtime19.jsxs)("div", { className: "Radio-body", children: [
        /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(
          "input",
          {
            ref,
            className: inputClassName,
            id: inputId,
            type: "radio",
            checked,
            value,
            disabled,
            name,
            onChange
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime19.jsx)("label", { className: "Radio-label", htmlFor: inputId, children: /* @__PURE__ */ (0, import_jsx_runtime19.jsx)("span", { className: "Radio-text", children: textLabel }) })
      ] }),
      helperText && /* @__PURE__ */ (0, import_jsx_runtime19.jsx)("div", { className: "Radio-helper-label", children: /* @__PURE__ */ (0, import_jsx_runtime19.jsx)("span", { className: "Radio-helper-text", children: helperText }) })
    ] });
  }
);
var Radio_default = Radio;

// src/components/RadioGroup/RadioGroup.tsx
var React10 = __toESM(require("react"));
var import_classnames8 = __toESM(require("classnames"));
var import_jsx_runtime20 = require("react/jsx-runtime");
var RadioGroup = React10.forwardRef(
  ({ children, name, onChange, error, disabled }, ref) => {
    const radioGroupErrorLabelClassName = React10.useMemo(
      () => (0, import_classnames8.default)("RadioGroupErrorLabel", {
        "RadioGroupErrorLabel--visible": !!error
      }),
      [error]
    );
    return /* @__PURE__ */ (0, import_jsx_runtime20.jsxs)(
      "fieldset",
      {
        className: "RadioGroup-root",
        "data-testid": "radio-group",
        name,
        disabled,
        children: [
          React10.Children.map(
            children,
            (child) => {
              if (React10.isValidElement(child)) {
                return React10.cloneElement(child, {
                  ...child.props,
                  name,
                  error,
                  onChange,
                  ref
                });
              }
              return child;
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime20.jsxs)("span", { className: radioGroupErrorLabelClassName, children: [
            /* @__PURE__ */ (0, import_jsx_runtime20.jsx)(ExclamationCircle_default, {}),
            error
          ] })
        ]
      }
    );
  }
);
var RadioGroup_default = RadioGroup;

// src/components/TextArea/TextArea.tsx
var React11 = __toESM(require("react"));
var import_classnames9 = __toESM(require("classnames"));
var import_jsx_runtime21 = require("react/jsx-runtime");
var TextArea = ({ label, error, required, helperText, ...attrs }, ref) => {
  const { className } = useTextAreaAttributes({ label, error, required });
  const inputErrorLabelClassName = React11.useMemo(
    () => (0, import_classnames9.default)("TextAreaErrorLabel", { "TextAreaErrorLabel--visible": !!error }),
    [error]
  );
  const helperTextClassName = React11.useMemo(
    () => (0, import_classnames9.default)("TextAreaHelperText", { "TextAreaHelperText--visible": !!helperText }),
    [error]
  );
  const requiredStatus = React11.useMemo(
    () => required ? /* @__PURE__ */ (0, import_jsx_runtime21.jsx)("span", { className: "TextAreaLabel--required", children: "*" }) : "",
    [required]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime21.jsxs)("div", { className: "TextArea", children: [
    /* @__PURE__ */ (0, import_jsx_runtime21.jsxs)("label", { className: "TextAreaLabel", children: [
      label,
      requiredStatus
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime21.jsx)("textarea", { ref, className, ...attrs }),
    /* @__PURE__ */ (0, import_jsx_runtime21.jsx)("span", { className: helperTextClassName, children: helperText }),
    /* @__PURE__ */ (0, import_jsx_runtime21.jsx)("span", { className: inputErrorLabelClassName, children: error })
  ] });
};
var TextArea_default = React11.forwardRef(TextArea);

// src/components/Tab/Tab.tsx
var import_classnames10 = __toESM(require("classnames"));
var import_jsx_runtime22 = require("react/jsx-runtime");
var Tab = ({
  isActive,
  onClick,
  tabId,
  label
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime22.jsx)(
    Typography_default,
    {
      variant: "body",
      color: isActive ? "primary" : "secondary",
      weight: isActive ? "medium" : "normal",
      children: /* @__PURE__ */ (0, import_jsx_runtime22.jsx)(
        "button",
        {
          "data-testid": "tab",
          className: (0, import_classnames10.default)(
            "whitespace-nowrap hover:text-green-1",
            isActive ? "tracking-tight" : ""
          ),
          onClick: () => onClick(tabId),
          children: label
        }
      )
    }
  );
};
var Tab_default = Tab;

// src/components/Tabs/Tabs.tsx
var import_jsx_runtime23 = require("react/jsx-runtime");
var Tabs = ({
  children,
  activeTabId,
  tabs,
  onSelectTab
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime23.jsxs)(
    "div",
    {
      "data-testid": "tabs",
      className: "relative flex h-full flex-1 flex-col p-0",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime23.jsx)("header", { className: "flex min-h-15 flex-row space-x-6 overflow-x-auto overflow-y-hidden px-10 py-6", children: tabs.map(({ id, label }) => /* @__PURE__ */ (0, import_jsx_runtime23.jsx)(
          Tab_default,
          {
            tabId: id,
            label,
            onClick: onSelectTab,
            isActive: id === activeTabId
          }
        )) }),
        /* @__PURE__ */ (0, import_jsx_runtime23.jsx)(import_jsx_runtime23.Fragment, { children: children({ activeTabId }) })
      ]
    }
  );
};
var Tabs_default = Tabs;

// src/components/MGPIFrame/MGPIFrame.tsx
var import_react4 = require("react");
var import_jsx_runtime24 = require("react/jsx-runtime");
var MGPIFrame = ({
  samlResponse,
  onLoad,
  onSafariCookieAccepted,
  captureException,
  renderCookieConfirmation,
  cookieConfirmationYOffset,
  mgpSSOUrl,
  mgpSafariCookieURL,
  isSafari
}) => {
  const [mgpCookieSet, setMgpCookieSet] = (0, import_react4.useState)(false);
  const iframeId = (0, import_react4.useMemo)(
    () => `mgp-sso-${(Math.random() + 1).toString(36)}`,
    []
  );
  const cookieConfirmRef = (0, import_react4.useRef)(null);
  const iframeRef = (0, import_react4.useRef)(null);
  const handleLoad = (0, import_react4.useCallback)(() => {
    onLoad();
  }, [onLoad]);
  const handleSafariCookieFix = (0, import_react4.useCallback)(
    (event) => {
      try {
        const { moneyGuideThirdPartyCookieFixSet } = JSON.parse(
          (event == null ? void 0 : event.data) ?? "{}"
        );
        if (moneyGuideThirdPartyCookieFixSet || event.isTrusted) {
          setMgpCookieSet(true);
          onSafariCookieAccepted();
          window.removeEventListener("message", handleSafariCookieFix);
        }
      } catch (err) {
        captureException(err);
      }
    },
    [onSafariCookieAccepted, captureException]
  );
  (0, import_react4.useEffect)(() => {
    if (cookieConfirmRef.current) {
      const y = cookieConfirmRef.current.getBoundingClientRect().top + window.pageYOffset + cookieConfirmationYOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  }, [cookieConfirmRef, cookieConfirmationYOffset]);
  (0, import_react4.useEffect)(() => {
    const iframeElement = iframeRef.current;
    if (iframeElement) {
      iframeElement.addEventListener("load", handleLoad);
    }
    return () => {
      if (iframeElement) {
        iframeElement.removeEventListener("load", handleLoad);
      }
    };
  }, [iframeRef, handleLoad]);
  (0, import_react4.useEffect)(() => {
    if (isSafari) {
      window.addEventListener("message", handleSafariCookieFix);
    }
    return () => {
      if (isSafari) {
        window.removeEventListener("message", handleSafariCookieFix);
      }
    };
  }, [isSafari, handleSafariCookieFix]);
  (0, import_react4.useEffect)(() => {
    if (samlResponse && (!isSafari || mgpCookieSet)) {
      const form = document.createElement("form");
      form.method = "POST";
      form.action = mgpSSOUrl;
      form.target = iframeId;
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "SamlResponse";
      input.value = samlResponse;
      form.appendChild(input);
      document.body.appendChild(form);
      form.submit();
    }
  }, [samlResponse, iframeId, mgpCookieSet, isSafari, mgpSSOUrl]);
  const onAcceptSafariCookie = (0, import_react4.useCallback)(() => {
    window.open(mgpSafariCookieURL, "_blank");
  }, [mgpSafariCookieURL]);
  if (isSafari && !mgpCookieSet) {
    return /* @__PURE__ */ (0, import_jsx_runtime24.jsx)("div", { ref: cookieConfirmRef, children: renderCookieConfirmation({ onAcceptCookie: onAcceptSafariCookie }) });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(
    "iframe",
    {
      "data-testid": "sso-iframe",
      ref: iframeRef,
      id: iframeId,
      name: iframeId,
      height: "100%",
      width: "100%"
    }
  );
};
var MGPIFrame_default = MGPIFrame;

// src/components/AdvisorTab/AdvisorTab.tsx
var React12 = __toESM(require("react"));
var import_classnames11 = __toESM(require("classnames"));
var import_jsx_runtime25 = require("react/jsx-runtime");
var AdvisorTab = ({
  isActive,
  onClick,
  tabId,
  label
}) => {
  const className = React12.useMemo(
    () => (0, import_classnames11.default)("AdvisorTab", {
      "AdvisorTab--active": isActive
    }),
    [isActive]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime25.jsx)(
    "button",
    {
      "data-testid": "advisor-tab",
      className,
      onClick: () => onClick(tabId),
      children: label
    }
  );
};
var AdvisorTab_default = AdvisorTab;

// src/components/AdvisorTabs/AdvisorTabs.tsx
var import_jsx_runtime26 = require("react/jsx-runtime");
var AdvisorTabs = ({
  children,
  activeTabId,
  tabs,
  onSelectTab
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime26.jsxs)("div", { "data-testid": "advisor-tabs", className: "AdvisorTabs", children: [
    /* @__PURE__ */ (0, import_jsx_runtime26.jsx)("header", { className: "AdvisorTabsHeader", children: tabs.map(({ id, label }) => /* @__PURE__ */ (0, import_jsx_runtime26.jsx)(
      AdvisorTab_default,
      {
        tabId: id,
        label,
        onClick: onSelectTab,
        isActive: id === activeTabId
      }
    )) }),
    /* @__PURE__ */ (0, import_jsx_runtime26.jsx)("div", { children: children({ activeTabId }) })
  ] });
};
var AdvisorTabs_default = AdvisorTabs;

// src/components/Dialog/Dialog.tsx
var import_react5 = require("@headlessui/react");
var import_react6 = require("react");
var import_hi = require("react-icons/hi");
var import_classnames12 = __toESM(require("classnames"));
var import_cg = require("react-icons/cg");
var import_jsx_runtime27 = require("react/jsx-runtime");
var _Dialog = ({
  isOpen,
  onClose,
  title,
  subtitle,
  headline,
  children,
  classNames,
  onSubmit,
  onSubmitText,
  onSubmitVariant = "primary",
  onCloseText = "Cancel",
  isSubmitting,
  showSubmitSpinner,
  hideX = false,
  size = "sm",
  titleItem,
  disableClose = false,
  hideCloseText = false
}) => {
  const classNamesBySize = {
    sm: {
      Background: (classNames == null ? void 0 : classNames.Background) ?? "",
      Panel: "min-w-[375px] max-w-[475px] md:min-w-[475px] " + ((classNames == null ? void 0 : classNames.Panel) ?? ""),
      Title: "pt-9 px-10 pb-6 " + ((classNames == null ? void 0 : classNames.Title) ?? ""),
      Description: "px-10 py-6 " + ((classNames == null ? void 0 : classNames.Description) ?? ""),
      Footer: "px-10 pb-6"
    },
    md: {
      Background: (classNames == null ? void 0 : classNames.Background) ?? "",
      Panel: "w-8/12 max-w-[635px] " + ((classNames == null ? void 0 : classNames.Panel) ?? ""),
      Title: "pt-9 px-10 pb-6 " + ((classNames == null ? void 0 : classNames.Title) ?? ""),
      Description: (classNames == null ? void 0 : classNames.Description) ?? "",
      Footer: "px-10 pb-6"
    },
    lg: {
      Background: (classNames == null ? void 0 : classNames.Background) ?? "",
      Panel: "w-8/12 max-w-[1200px] " + ((classNames == null ? void 0 : classNames.Panel) ?? ""),
      Title: "pt-9 px-10 pb-6 " + ((classNames == null ? void 0 : classNames.Title) ?? ""),
      Description: (classNames == null ? void 0 : classNames.Description) ?? "",
      Footer: "px-10 pb-6"
    },
    xl: {
      Background: (classNames == null ? void 0 : classNames.Background) ?? "",
      Panel: "w-full h-full " + ((classNames == null ? void 0 : classNames.Panel) ?? ""),
      Title: "pt-9 px-10 pb-6 " + ((classNames == null ? void 0 : classNames.Title) ?? ""),
      Description: (classNames == null ? void 0 : classNames.Description) ?? "",
      Footer: "px-10 pb-6"
    },
    full: {
      Background: "bg-white " + ((classNames == null ? void 0 : classNames.Background) ?? ""),
      Panel: "w-full max-w-[674px] " + ((classNames == null ? void 0 : classNames.Panel) ?? ""),
      Title: "pt-9 px-10 pb-6 " + ((classNames == null ? void 0 : classNames.Title) ?? ""),
      Description: (classNames == null ? void 0 : classNames.Description) ?? "",
      Footer: "px-10 pb-6"
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime27.jsx)(import_react5.Transition, { appear: true, show: isOpen, as: import_react6.Fragment, children: /* @__PURE__ */ (0, import_jsx_runtime27.jsxs)(
    import_react5.Dialog,
    {
      open: isOpen,
      onClose: disableClose ? () => void 0 : onClose,
      className: "relative z-[80]",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime27.jsx)(
          import_react5.Transition.Child,
          {
            as: import_react6.Fragment,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0",
            enterTo: "opacity-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100",
            leaveTo: "opacity-0",
            children: /* @__PURE__ */ (0, import_jsx_runtime27.jsx)(
              "div",
              {
                className: "fixed inset-0 bg-overlay " + classNamesBySize[size]["Background"]
              }
            )
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime27.jsx)("div", { className: "fixed inset-0 overflow-y-auto", children: /* @__PURE__ */ (0, import_jsx_runtime27.jsx)(
          "div",
          {
            className: (0, import_classnames12.default)(
              "flex min-h-full justify-center",
              size !== "full" && "items-center p-4",
              size === "xl" && "h-screen"
            ),
            children: /* @__PURE__ */ (0, import_jsx_runtime27.jsx)(
              import_react5.Transition.Child,
              {
                as: import_react6.Fragment,
                enter: "ease-out duration-300",
                enterFrom: "opacity-0 scale-95",
                enterTo: "opacity-100 scale-100",
                leave: "ease-in duration-200",
                leaveFrom: "opacity-100 scale-100",
                leaveTo: "opacity-0 scale-95",
                children: /* @__PURE__ */ (0, import_jsx_runtime27.jsxs)(
                  import_react5.Dialog.Panel,
                  {
                    className: (0, import_classnames12.default)(
                      size !== "full" && "rounded-lg border border-primary bg-white shadow-md",
                      classNamesBySize[size]["Panel"]
                    ),
                    children: [
                      (title || headline || titleItem) && /* @__PURE__ */ (0, import_jsx_runtime27.jsxs)(
                        import_react5.Dialog.Title,
                        {
                          className: "flex flex-row items-start justify-between px-10 pb-6 pt-9 " + classNamesBySize[size]["Title"],
                          children: [
                            title ? /* @__PURE__ */ (0, import_jsx_runtime27.jsxs)("div", { className: "flex flex-col gap-0", children: [
                              /* @__PURE__ */ (0, import_jsx_runtime27.jsx)(
                                Typography_default,
                                {
                                  variant: "body-lg",
                                  weight: "medium",
                                  color: "primary",
                                  children: title
                                }
                              ),
                              subtitle && /* @__PURE__ */ (0, import_jsx_runtime27.jsx)(Typography_default, { variant: "body-sm", color: "primary", children: subtitle })
                            ] }) : /* @__PURE__ */ (0, import_jsx_runtime27.jsx)(
                              Typography_default,
                              {
                                variant: "title-xl",
                                color: "primary",
                                weight: "medium",
                                children: headline
                              }
                            ),
                            titleItem,
                            !hideX && !disableClose && /* @__PURE__ */ (0, import_jsx_runtime27.jsx)("button", { onClick: onClose, className: "ml-4", children: /* @__PURE__ */ (0, import_jsx_runtime27.jsx)(import_hi.HiX, { className: "flex-none", size: 24 }) })
                          ]
                        }
                      ),
                      /* @__PURE__ */ (0, import_jsx_runtime27.jsx)(
                        import_react5.Dialog.Description,
                        {
                          as: "div",
                          className: "flex flex-col pt-0 " + classNamesBySize[size]["Description"],
                          children
                        }
                      ),
                      onSubmit && /* @__PURE__ */ (0, import_jsx_runtime27.jsxs)(
                        "div",
                        {
                          className: (0, import_classnames12.default)(
                            classNamesBySize[size]["Footer"],
                            "flex flex-row justify-end gap-2"
                          ),
                          children: [
                            !hideCloseText && /* @__PURE__ */ (0, import_jsx_runtime27.jsx)(Button_default, { onClick: onClose, variant: "tertiary", children: onCloseText }),
                            /* @__PURE__ */ (0, import_jsx_runtime27.jsx)(
                              Button_default,
                              {
                                onClick: onSubmit,
                                variant: onSubmitVariant,
                                disabled: isSubmitting,
                                children: isSubmitting && showSubmitSpinner ? /* @__PURE__ */ (0, import_jsx_runtime27.jsx)(
                                  import_cg.CgSpinner,
                                  {
                                    size: 16,
                                    color: "dark-gray",
                                    className: "animate-spin"
                                  }
                                ) : onSubmitText
                              }
                            )
                          ]
                        }
                      )
                    ]
                  }
                )
              }
            )
          }
        ) })
      ]
    }
  ) });
};
var Dialog_default = _Dialog;

// src/components/Tooltip/Tooltip.tsx
var import_react8 = require("react");
var import_react9 = require("@headlessui/react");
var import_react_dom = require("@floating-ui/react-dom");
var import_hi2 = require("react-icons/hi");

// src/components/AutoCloser/AutoCloser.tsx
var import_react7 = require("react");
var AutoCloser = ({
  open,
  autoClose,
  closeAfter,
  close
}) => {
  (0, import_react7.useEffect)(() => {
    if (!autoClose || !open)
      return;
    const timer = setTimeout(close, closeAfter);
    return () => clearTimeout(timer);
  }, [open, autoClose, closeAfter, close]);
  return null;
};
var AutoCloser_default = AutoCloser;

// src/components/Tooltip/Tooltip.tsx
var import_react_dom2 = require("react-dom");
var import_jsx_runtime28 = require("react/jsx-runtime");
var PortalWrapper = ({ children }) => {
  return (0, import_react_dom2.createPortal)(/* @__PURE__ */ (0, import_jsx_runtime28.jsx)(import_jsx_runtime28.Fragment, { children }), document.body);
};
var Tooltip = ({
  children,
  description,
  title,
  placement = "bottom",
  autoClose = false,
  closeAfter = 1e3
}) => {
  const { x, y, reference, floating, strategy } = (0, import_react_dom.useFloating)({
    placement,
    strategy: "fixed",
    middleware: [(0, import_react_dom.flip)(), (0, import_react_dom.offset)(8), (0, import_react_dom.shift)()],
    whileElementsMounted: import_react_dom.autoUpdate
  });
  return /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(import_jsx_runtime28.Fragment, { children: /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(import_react9.Popover, { as: import_react8.Fragment, children: ({ close, open }) => {
    return /* @__PURE__ */ (0, import_jsx_runtime28.jsxs)(import_jsx_runtime28.Fragment, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(
        AutoCloser_default,
        {
          autoClose,
          closeAfter,
          close,
          open
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(import_react9.Popover.Button, { tabIndex: -1, ref: reference, className: "w-full", children }),
      /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(
        import_react9.Transition,
        {
          as: import_react8.Fragment,
          enter: "transition ease-out duration-200",
          enterFrom: "opacity-0 translate-y-1",
          enterTo: "opacity-100 translate-y-0",
          leave: "transition ease-in duration-150",
          leaveFrom: "opacity-100 translate-y-0",
          leaveTo: "opacity-0 translate-y-1",
          children: /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(import_react9.Popover.Panel, { className: "absolute z-10", children: /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(PortalWrapper, { children: /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(
            "div",
            {
              className: "z-[100] flex w-[300px] max-w-[300px] flex-col rounded-lg border border-gray-200 bg-white p-6 font-medium leading-4 shadow-sm",
              ref: floating,
              style: {
                position: strategy,
                top: y ?? "",
                left: x ?? ""
              },
              children: /* @__PURE__ */ (0, import_jsx_runtime28.jsx)("div", { className: "flex flex-row items-start space-x-2", children: /* @__PURE__ */ (0, import_jsx_runtime28.jsxs)("div", { className: "flex flex-col space-y-[10px]", children: [
                /* @__PURE__ */ (0, import_jsx_runtime28.jsxs)("div", { className: "flex items-start justify-between", children: [
                  title && /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(
                    Typography_default,
                    {
                      variant: "body",
                      weight: "medium",
                      color: "primary",
                      children: title
                    }
                  ),
                  !autoClose && /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(
                    "button",
                    {
                      onClick: (e) => {
                        e.preventDefault();
                        close();
                      },
                      children: /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(import_hi2.HiX, { size: 24, className: "text-primary" })
                    }
                  )
                ] }),
                description && /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(import_jsx_runtime28.Fragment, { children: typeof description === "string" ? /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(Typography_default, { variant: "body", color: "primary", children: description }) : description })
              ] }) })
            }
          ) }) })
        }
      )
    ] });
  } }) });
};
var Tooltip_default = Tooltip;

// src/components/Table/Table.tsx
var import_react_table3 = require("@tanstack/react-table");

// src/components/Table/DefaultTableRow.tsx
var import_react_table = require("@tanstack/react-table");
var import_jsx_runtime29 = require("react/jsx-runtime");
function DefaultTableRow({
  cell,
  className
}) {
  if (!cell) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime29.jsx)(
    "td",
    {
      className,
      style: {
        width: cell.column.getSize(),
        minWidth: `${cell.column.columnDef.minSize}px`,
        maxWidth: `${cell.column.columnDef.maxSize}px`
      },
      children: (0, import_react_table.flexRender)(cell.column.columnDef.cell, cell.getContext())
    },
    cell.id
  );
}

// src/components/Table/TableRow.tsx
var import_jsx_runtime30 = require("react/jsx-runtime");
function TableRow({
  cell,
  children,
  className
}) {
  if (!cell) {
    return null;
  }
  if (typeof children === "function") {
    return /* @__PURE__ */ (0, import_jsx_runtime30.jsx)(import_jsx_runtime30.Fragment, { children: children(cell) });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime30.jsx)(DefaultTableRow, { cell, className });
}

// src/components/Table/DefaultTableHeader.tsx
var import_hi3 = require("react-icons/hi");
var import_react_table2 = require("@tanstack/react-table");
var import_hi4 = require("react-icons/hi");
var import_classnames13 = __toESM(require("classnames"));
var import_jsx_runtime31 = require("react/jsx-runtime");
function DefaultTableHeader({
  header,
  className
}) {
  if (!header) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(
    "th",
    {
      className: (0, import_classnames13.default)(className, {
        "cursor-pointer select-none": header.column.getCanSort()
      }),
      style: {
        width: header.getSize(),
        minWidth: `${header.column.columnDef.minSize}px`,
        maxWidth: `${header.column.columnDef.maxSize}px`
      },
      colSpan: header.colSpan,
      onClick: header.column.getToggleSortingHandler(),
      children: /* @__PURE__ */ (0, import_jsx_runtime31.jsxs)("div", { className: "group flex items-center gap-2", children: [
        header.isPlaceholder ? null : (0, import_react_table2.flexRender)(header.column.columnDef.header, header.getContext()),
        {
          asc: /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(import_hi4.HiArrowUp, { size: 16 }),
          desc: /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(import_hi3.HiArrowDown, { size: 16 })
        }[header.column.getIsSorted()] ?? null,
        /* @__PURE__ */ (0, import_jsx_runtime31.jsx)("div", { className: "invisible group-hover:visible", children: !header.column.getIsSorted() && header.column.getCanSort() && /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(import_hi4.HiArrowUp, { size: 16 }) })
      ] })
    },
    header.id
  );
}

// src/components/Table/TableHeader.tsx
var import_jsx_runtime32 = require("react/jsx-runtime");
function TableHeader({
  header,
  className,
  children
}) {
  if (!header) {
    return null;
  }
  if (typeof children === "function") {
    return /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(import_jsx_runtime32.Fragment, { children: children(header) });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(DefaultTableHeader, { header, className });
}

// src/components/Table/TableRows.tsx
var React13 = __toESM(require("react"));
var import_jsx_runtime33 = require("react/jsx-runtime");
function TableRows({
  children,
  cell,
  className
}) {
  const hasCustomRow = React13.Children.toArray(children).some(
    (child) => React13.isValidElement(child) && child.type === Table.Row
  );
  if (!hasCustomRow) {
    return /* @__PURE__ */ (0, import_jsx_runtime33.jsx)(DefaultTableRow, { cell, className });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime33.jsx)(import_jsx_runtime33.Fragment, { children: React13.Children.map(children, (child) => {
    if (React13.isValidElement(child) && child.type === Table.Row) {
      return React13.cloneElement(
        child,
        { cell }
      );
    }
    return null;
  }) });
}
var TableRows_default = TableRows;

// src/components/Table/TableHeaders.tsx
var React14 = __toESM(require("react"));
var import_jsx_runtime34 = require("react/jsx-runtime");
function TableHeaders({
  children,
  header,
  className
}) {
  const hasCustomHeader = React14.Children.toArray(children).some(
    (child) => React14.isValidElement(child) && child.type === Table.Header
  );
  if (!hasCustomHeader) {
    return /* @__PURE__ */ (0, import_jsx_runtime34.jsx)(DefaultTableHeader, { header, className });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime34.jsx)(import_jsx_runtime34.Fragment, { children: React14.Children.map(children, (child) => {
    if (React14.isValidElement(child) && child.type === Table.Header) {
      return React14.cloneElement(
        child,
        { header }
      );
    }
    return null;
  }) });
}
var TableHeaders_default = TableHeaders;

// src/components/Table/Table.tsx
var import_jsx_runtime35 = require("react/jsx-runtime");
function Table({ table, children }) {
  return /* @__PURE__ */ (0, import_jsx_runtime35.jsxs)("table", { className: "w-full", children: [
    /* @__PURE__ */ (0, import_jsx_runtime35.jsx)("thead", { children: table.getHeaderGroups().map((headerGroup) => /* @__PURE__ */ (0, import_jsx_runtime35.jsx)("tr", { children: headerGroup.headers.map((header) => /* @__PURE__ */ (0, import_jsx_runtime35.jsx)(TableHeaders_default, { header, children }, header.id)) }, headerGroup.id)) }),
    /* @__PURE__ */ (0, import_jsx_runtime35.jsx)("tbody", { children: table.getRowModel().rows.map((row) => /* @__PURE__ */ (0, import_jsx_runtime35.jsx)("tr", { className: "hover:bg-offwhite", children: row.getVisibleCells().map((cell) => /* @__PURE__ */ (0, import_jsx_runtime35.jsx)(TableRows_default, { cell, children }, cell.id)) }, row.id)) }),
    /* @__PURE__ */ (0, import_jsx_runtime35.jsx)("tfoot", { children: table.getFooterGroups().map((footerGroup) => /* @__PURE__ */ (0, import_jsx_runtime35.jsx)("tr", { children: footerGroup.headers.map((header) => /* @__PURE__ */ (0, import_jsx_runtime35.jsx)("th", { children: header.isPlaceholder ? null : (0, import_react_table3.flexRender)(
      header.column.columnDef.footer,
      header.getContext()
    ) }, header.id)) }, footerGroup.id)) })
  ] });
}
Table.Row = TableRow;
Table.Header = TableHeader;

// src/components/BackButton/BackButton.tsx
var import_hi5 = require("react-icons/hi");
var import_jsx_runtime36 = require("react/jsx-runtime");
var BackButton = ({ onClick }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime36.jsxs)(
    "button",
    {
      className: "-ml-1.5 flex flex-row items-center space-x-1",
      onClick,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(import_hi5.HiChevronLeft, { size: 24 }),
        /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(Typography_default, { variant: "body-xl", weight: "medium", children: "Back" })
      ]
    }
  );
};
var BackButton_default = BackButton;

// src/components/DatePicker/DatePicker.tsx
var React15 = __toESM(require("react"));
var import_react_dates = require("react-dates");
var import_initialize = require("react-dates/initialize");
var import_hi6 = require("react-icons/hi");
var import_react_dom3 = require("@floating-ui/react-dom");
var import_classnames14 = __toESM(require("classnames"));
var import_moment = __toESM(require("moment"));
var import_react_input_mask2 = __toESM(require("@mona-health/react-input-mask"));
var import_jsx_runtime37 = require("react/jsx-runtime");
var DatePicker = ({
  date,
  onDateChange = () => void 0,
  disabled,
  displayFormat = "MM/DD/YYYY",
  label,
  required,
  showOptional
}) => {
  var _a;
  const [focused, setFocused] = React15.useState(false);
  const inputRef = React15.useRef(null);
  const observerRef = React15.useRef(null);
  const getUTCDate = (date2) => {
    return date2 ? import_moment.default.utc(date2) : null;
  };
  const findCalendarElement = React15.useCallback(() => {
    const selector = ".DayPicker_portal__horizontal";
    const element = document.querySelector(selector);
    if (element) {
      if (element instanceof HTMLElement) {
        return element;
      }
    }
    return null;
  }, []);
  const positionCalendar = React15.useCallback(() => {
    if (!inputRef.current)
      return;
    const calendarElement = findCalendarElement();
    if (!calendarElement) {
      requestAnimationFrame(positionCalendar);
      return;
    }
    calendarElement.style.opacity = "0";
    (0, import_react_dom3.computePosition)(inputRef.current, calendarElement, {
      placement: "bottom-start",
      middleware: [(0, import_react_dom3.offset)(5), (0, import_react_dom3.flip)(), (0, import_react_dom3.shift)()]
    }).then(
      ({ x, y, strategy }) => {
        Object.assign(calendarElement.style, {
          position: strategy,
          left: `${x}px`,
          top: `${y}px`,
          zIndex: "1000",
          transform: "none",
          margin: "0",
          transition: "opacity 0.15s ease"
        });
        requestAnimationFrame(() => {
          calendarElement.style.opacity = "1";
        });
      }
    );
  }, [findCalendarElement]);
  const handleWindowEvents = React15.useCallback(() => {
    positionCalendar();
  }, [positionCalendar]);
  React15.useEffect(() => {
    if (focused) {
      const attempt = () => {
        const calendarElement = findCalendarElement();
        if (calendarElement) {
          positionCalendar();
          return true;
        }
        return false;
      };
      if (!attempt()) {
        requestAnimationFrame(() => {
          if (!attempt()) {
            const observer = new MutationObserver(() => {
              if (attempt()) {
                observer.disconnect();
              }
            });
            observer.observe(document.body, {
              childList: true,
              subtree: true
            });
            observerRef.current = observer;
          }
        });
      }
      window.addEventListener("resize", handleWindowEvents);
      window.addEventListener("scroll", handleWindowEvents, true);
      return () => {
        if (observerRef.current) {
          observerRef.current.disconnect();
        }
        window.removeEventListener("resize", handleWindowEvents);
        window.removeEventListener("scroll", handleWindowEvents, true);
      };
    }
  }, [focused, positionCalendar, handleWindowEvents, findCalendarElement]);
  const onFocusChange = ({ focused: focused2 }) => {
    setFocused(focused2);
  };
  const onDateChangeHandler = (date2) => {
    if (date2) {
      const utcDate = import_moment.default.utc();
      utcDate.set({
        year: date2.year(),
        month: date2.month(),
        date: date2.date(),
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0
      });
      onDateChange(utcDate);
    } else {
      onDateChange(null);
    }
    setFocused(false);
  };
  const [displayValue, setDisplayValue] = React15.useState(
    date ? ((_a = getUTCDate(date)) == null ? void 0 : _a.format(displayFormat)) || "" : ""
  );
  React15.useEffect(() => {
    var _a2;
    setDisplayValue(date ? ((_a2 = getUTCDate(date)) == null ? void 0 : _a2.format(displayFormat)) || "" : "");
  }, [date, displayFormat]);
  const handleInputChange = (e) => {
    const value = e.target.value;
    setDisplayValue(value);
    if (value.replace(/[^0-9]/g, "").length === 8) {
      const [month, day, year] = value.split(/[^0-9]+/).filter(Boolean);
      const newDate = import_moment.default.utc();
      newDate.set({
        year: parseInt(year, 10),
        month: parseInt(month, 10) - 1,
        // moment months are 0-based
        date: parseInt(day, 10),
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0
      });
      if (newDate.isValid()) {
        onDateChange(newDate);
      }
    } else if (!value) {
      onDateChange(null);
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime37.jsxs)(import_jsx_runtime37.Fragment, { children: [
    label && /* @__PURE__ */ (0, import_jsx_runtime37.jsx)(
      InputLabel_default,
      {
        label,
        required,
        showOptional
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime37.jsxs)(
      "div",
      {
        ref: inputRef,
        className: "relative flex min-w-[166px] select-none items-center",
        onClick: (e) => {
          if (!disabled) {
            e.stopPropagation();
            setFocused(true);
          }
        },
        tabIndex: 0,
        onKeyDown: (e) => {
          if (e.key === "Enter") {
            !disabled && setFocused(true);
          }
        },
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime37.jsx)("div", { className: "absolute left-[11px] text-primary-black", children: /* @__PURE__ */ (0, import_jsx_runtime37.jsx)(import_hi6.HiOutlineCalendar, { size: 24 }) }),
          /* @__PURE__ */ (0, import_jsx_runtime37.jsx)(
            import_react_input_mask2.default,
            {
              mask: "99/99/9999",
              maskPlaceholder: focused ? "" : "_",
              type: "text",
              disabled,
              value: displayValue,
              onChange: handleInputChange,
              onFocus: () => setFocused(true),
              className: (0, import_classnames14.default)(
                "w-full rounded border border-gray-400 py-2 pl-10 pr-[5px] focus:ring-0",
                { "bg-gray-50": disabled }
              ),
              placeholder: displayFormat
            }
          ),
          date && /* @__PURE__ */ (0, import_jsx_runtime37.jsx)(
            "button",
            {
              className: "DatePickerXIcon",
              onClick: (e) => {
                e.stopPropagation();
                e.preventDefault();
                setDisplayValue("");
                onDateChange(null);
              },
              disabled,
              children: /* @__PURE__ */ (0, import_jsx_runtime37.jsx)(import_hi6.HiX, { size: 24 })
            }
          )
        ]
      }
    ),
    focused && /* @__PURE__ */ (0, import_jsx_runtime37.jsx)("div", { onClick: (e) => e.stopPropagation(), children: /* @__PURE__ */ (0, import_jsx_runtime37.jsx)(
      import_react_dates.DayPickerSingleDateController,
      {
        date: getUTCDate(date),
        onDateChange: onDateChangeHandler,
        focused,
        onFocusChange,
        initialVisibleMonth: () => import_moment.default.utc().add(14, "days"),
        onOutsideClick: () => setFocused(false),
        withPortal: true,
        isOutsideRange: (day) => day.isBefore(import_moment.default.utc(), "day"),
        hideKeyboardShortcutsPanel: true
      }
    ) })
  ] });
};
var DatePicker_default = DatePicker;

// src/components/ToggleButton/ToggleButton.tsx
var React16 = __toESM(require("react"));
var import_jsx_runtime38 = require("react/jsx-runtime");
var ToggleButton = ({
  leftLabel,
  rightLabel,
  value,
  onChange,
  rightDisabled = false,
  leftDisabled = false,
  className,
  ariaLabel,
  size = "md"
}) => {
  const typographyVariant = size === "sm" ? "body-xs" : "body";
  const isControlled = value !== void 0;
  const [internal, setInternal] = React16.useState();
  const selected = (isControlled ? value : internal) ?? "left";
  const setSelected = (v) => {
    if (leftDisabled && rightDisabled)
      return;
    if (!isControlled)
      setInternal(v);
    onChange == null ? void 0 : onChange(v);
  };
  const leftChecked = selected === "left";
  const rightChecked = !leftChecked;
  return /* @__PURE__ */ (0, import_jsx_runtime38.jsxs)(
    "div",
    {
      role: "radiogroup",
      "aria-label": ariaLabel,
      "aria-disabled": leftDisabled && rightDisabled || void 0,
      className: [
        "Toggle",
        size === "sm" ? "Toggle--sm" : "",
        leftDisabled && rightDisabled ? "is-disabled" : "",
        className
      ].filter(Boolean).join(" "),
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(
          "button",
          {
            type: "button",
            role: "radio",
            "aria-checked": leftChecked,
            "data-value": "left",
            className: [
              "ToggleButton ToggleButton-left",
              leftChecked ? "bg-green-30" : ""
            ].filter(Boolean).join(" "),
            tabIndex: leftChecked ? 0 : -1,
            disabled: leftDisabled,
            onClick: () => setSelected("left"),
            children: /* @__PURE__ */ (0, import_jsx_runtime38.jsx)("span", { className: "ToggleButtonLabel", children: /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(Typography_default, { weight: "medium", variant: typographyVariant, color: "black", children: leftLabel }) })
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(
          "button",
          {
            type: "button",
            role: "radio",
            "aria-checked": rightChecked,
            "data-value": "right",
            className: [
              "ToggleButton ToggleButton-right",
              rightChecked ? "bg-green-30" : ""
            ].filter(Boolean).join(" "),
            tabIndex: rightChecked ? 0 : -1,
            disabled: rightDisabled,
            onClick: () => setSelected("right"),
            children: /* @__PURE__ */ (0, import_jsx_runtime38.jsx)("span", { className: "ToggleButtonLabel", children: /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(Typography_default, { weight: "medium", variant: typographyVariant, color: "black", children: rightLabel }) })
          }
        )
      ]
    }
  );
};
var ToggleButton_default = ToggleButton;

// src/components/Stepper/Stepper.tsx
var import_hi7 = require("react-icons/hi");
var import_jsx_runtime39 = require("react/jsx-runtime");
var Stepper = ({ steps, activeStep }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime39.jsx)("div", { className: "StepperContainer", children: steps.map((label, index) => {
    const isCompleted = index < activeStep;
    const isActive = index === activeStep;
    const getStepCircleClass = () => {
      if (isCompleted) {
        if (index === 0) {
          return "StepCircle StepCircle--completed StepCircle--left";
        } else if (index === steps.length - 1) {
          return "StepCircle StepCircle--completed StepCircle--right";
        }
        return "StepCircle StepCircle--completed";
      }
      if (isActive) {
        if (index === 0) {
          return "StepCircle StepCircle--active StepCircle--left";
        } else if (index === steps.length - 1) {
          return "StepCircle StepCircle--active StepCircle--right";
        }
        return "StepCircle StepCircle--active";
      }
      if (index === 0) {
        return "StepCircle StepCircle--inactive StepCircle--left";
      } else if (index === steps.length - 1) {
        return "StepCircle StepCircle--inactive StepCircle--right";
      }
      return "StepCircle StepCircle--inactive";
    };
    const getLabelClass = () => {
      if (index === 0) {
        return "w-full mt-2 text-start";
      } else if (index === steps.length - 1) {
        return "w-full mt-2 text-end";
      } else {
        return "w-full mt-2 text-center";
      }
    };
    return /* @__PURE__ */ (0, import_jsx_runtime39.jsxs)("div", { className: "StepWrapper", children: [
      /* @__PURE__ */ (0, import_jsx_runtime39.jsxs)("div", { className: "StepIndicatorRow", children: [
        index > 0 && /* @__PURE__ */ (0, import_jsx_runtime39.jsx)("div", { className: "ConnectorLine ConnectorLine--visible" }),
        /* @__PURE__ */ (0, import_jsx_runtime39.jsx)("div", { className: getStepCircleClass(), children: isCompleted ? /* @__PURE__ */ (0, import_jsx_runtime39.jsx)(import_hi7.HiCheck, { color: "white", size: 24 }) : /* @__PURE__ */ (0, import_jsx_runtime39.jsx)(
          Typography_default,
          {
            variant: "body",
            weight: "medium",
            color: isActive ? "light" : "secondary-gray",
            children: index + 1
          }
        ) }),
        index < steps.length - 1 && /* @__PURE__ */ (0, import_jsx_runtime39.jsx)("div", { className: "ConnectorLine ConnectorLine--visible" })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime39.jsx)("div", { className: getLabelClass(), children: /* @__PURE__ */ (0, import_jsx_runtime39.jsx)(Typography_default, { variant: "body-sm", weight: "medium", color: "black", children: label }) })
    ] }, index);
  }) });
};
var Stepper_default = Stepper;

// src/components/Accordion/Accordion.tsx
var React17 = __toESM(require("react"));
var import_hi8 = require("react-icons/hi");
var import_jsx_runtime40 = require("react/jsx-runtime");
var Accordion = ({
  items,
  singleOpen = false,
  className
}) => {
  const [open, setOpen] = React17.useState([]);
  const toggle = (i) => setOpen(
    (prev) => singleOpen ? prev[0] === i ? [] : [i] : prev.includes(i) ? prev.filter((x) => x !== i) : [...prev, i]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime40.jsx)("div", { className, children: items.map((item, i) => {
    const isOpen = open.includes(i);
    const summaryId = `acc-summary-${i}`;
    const panelId = `acc-panel-${i}`;
    return /* @__PURE__ */ (0, import_jsx_runtime40.jsxs)("div", { className: "AccordionItem", children: [
      /* @__PURE__ */ (0, import_jsx_runtime40.jsxs)(
        "button",
        {
          type: "button",
          id: summaryId,
          className: "AccordionSummary flex flex-row justify-between",
          "aria-expanded": isOpen,
          "aria-controls": panelId,
          onClick: () => toggle(i),
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime40.jsx)("span", { className: "AccordionLabel", children: /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(Typography_default, { variant: "body", color: "primary", weight: "medium", children: item.header }) }),
            /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(
              import_hi8.HiChevronDown,
              {
                size: 24,
                className: (isOpen ? "rotate-180" : "") + " mr-2 transition-all duration-300"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(
        "div",
        {
          id: panelId,
          role: "region",
          "aria-labelledby": summaryId,
          className: "AccordionPanel",
          hidden: !isOpen,
          children: /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(Typography_default, { variant: "body", color: "black", children: item.copy })
        }
      )
    ] }, i);
  }) });
};
var Accordion_default = Accordion;

// src/components/Markup/Markup.tsx
var React18 = __toESM(require("react"));
var import_jsx_runtime41 = require("react/jsx-runtime");
var transformPlainText = (s) => (
  // Two or more consecutive hyphens → em dash. Only applied to plain-text
  // segments (inline code in backticks is matched separately and skipped).
  s.replace(/--+/g, "\u2014")
);
var parseInline = (text) => {
  const pattern = /\*\*([^*]+)\*\*|\*([^*]+)\*|`([^`]+)`|\[([^\]]+)\]\(([^\s()]+\.vtt)\)|\[([^\]]+)\]\((https?:\/\/[^\s()]*(?:\([^\s()]*\)[^\s()]*)*)\)|\{(REDACTED)\}/g;
  const nodes = [];
  let last = 0;
  let key = 0;
  let match;
  while ((match = pattern.exec(text)) !== null) {
    if (match.index > last) {
      nodes.push(transformPlainText(text.slice(last, match.index)));
    }
    if (match[1] !== void 0) {
      nodes.push(/* @__PURE__ */ (0, import_jsx_runtime41.jsx)("strong", { children: parseInline(match[1]) }, key++));
    } else if (match[2] !== void 0) {
      nodes.push(/* @__PURE__ */ (0, import_jsx_runtime41.jsx)("em", { children: parseInline(match[2]) }, key++));
    } else if (match[3] !== void 0) {
      nodes.push(
        /* @__PURE__ */ (0, import_jsx_runtime41.jsx)("code", { className: "Markup-code-inline", children: match[3] }, key++)
      );
    } else if (match[4] !== void 0) {
      nodes.push(
        /* @__PURE__ */ (0, import_jsx_runtime41.jsxs)("span", { className: "Markup-file-ref", children: [
          match[4],
          /* @__PURE__ */ (0, import_jsx_runtime41.jsx)("span", { className: "Markup-file-ref-tooltip", children: match[5] })
        ] }, key++)
      );
    } else if (match[6] !== void 0) {
      nodes.push(
        /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(
          "a",
          {
            href: match[7],
            target: "_blank",
            rel: "noopener noreferrer",
            style: { color: "#0053CF", textDecoration: "underline" },
            children: match[6]
          },
          key++
        )
      );
    } else if (match[8] !== void 0) {
      nodes.push(
        /* @__PURE__ */ (0, import_jsx_runtime41.jsx)("span", { className: "Markup-redacted", children: "Redacted" }, key++)
      );
    }
    last = match.index + match[0].length;
  }
  if (last < text.length) {
    nodes.push(transformPlainText(text.slice(last)));
  }
  return /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(import_jsx_runtime41.Fragment, { children: nodes });
};
var Markup = ({ content, className }) => {
  const blocks = React18.useMemo(() => {
    const normalized = content.replace(
      /(\[[^\]]+\])\n(\(https?:\/\/[^\s()]*(?:\([^\s()]*\)[^\s()]*)*\))/g,
      "$1$2"
    ).replace(/(\[[^\]]+\])\n(\([^\s()]+\.vtt\))/g, "$1$2");
    const lines = normalized.split("\n");
    const result = [];
    let i = 0;
    let key = 0;
    let listItems = [];
    let listType = null;
    let olStartCount = 0;
    const renderItem = (item, j) => /* @__PURE__ */ (0, import_jsx_runtime41.jsxs)("li", { className: "Markup-list-item", children: [
      parseInline(item.text),
      item.subList && (item.subList.type === "ul" ? /* @__PURE__ */ (0, import_jsx_runtime41.jsx)("ul", { className: "Markup-list Markup-list--ul", children: item.subList.items.map((child, k) => /* @__PURE__ */ (0, import_jsx_runtime41.jsx)("li", { className: "Markup-list-item", children: parseInline(child) }, k)) }) : /* @__PURE__ */ (0, import_jsx_runtime41.jsx)("ol", { className: "Markup-list Markup-list--ol", children: item.subList.items.map((child, k) => /* @__PURE__ */ (0, import_jsx_runtime41.jsx)("li", { className: "Markup-list-item", children: parseInline(child) }, k)) }))
    ] }, j);
    const flushList = () => {
      if (!listItems.length)
        return;
      if (listType === "ul") {
        result.push(
          /* @__PURE__ */ (0, import_jsx_runtime41.jsx)("ul", { className: "Markup-list Markup-list--ul", children: listItems.map(renderItem) }, key++)
        );
      } else {
        const start = olStartCount + 1;
        olStartCount += listItems.length;
        result.push(
          /* @__PURE__ */ (0, import_jsx_runtime41.jsx)("ol", { start, className: "Markup-list Markup-list--ol", children: listItems.map(renderItem) }, key++)
        );
      }
      listItems = [];
      listType = null;
    };
    while (i < lines.length) {
      const line = lines[i];
      if (line.startsWith("|")) {
        flushList();
        olStartCount = 0;
        const tableLines = [];
        while (i < lines.length && lines[i].startsWith("|")) {
          tableLines.push(lines[i]);
          i++;
        }
        const [headerRow, , ...dataRows] = tableLines;
        const parseRow = (row) => row.split("|").slice(1, -1).map((cell) => cell.trim());
        const headers = parseRow(headerRow);
        result.push(
          /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(
            "div",
            {
              style: { overflowX: "auto", marginBottom: "0.75rem" },
              children: /* @__PURE__ */ (0, import_jsx_runtime41.jsxs)(
                "table",
                {
                  style: {
                    width: "100%",
                    borderCollapse: "collapse",
                    fontSize: "0.875rem"
                  },
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime41.jsx)("thead", { children: /* @__PURE__ */ (0, import_jsx_runtime41.jsx)("tr", { children: headers.map((h, j) => /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(
                      "th",
                      {
                        style: {
                          border: "1px solid #e5e7eb",
                          backgroundColor: "#f9fafb",
                          padding: "0.625rem 1rem",
                          textAlign: "left",
                          fontWeight: 500
                        },
                        children: parseInline(h)
                      },
                      j
                    )) }) }),
                    /* @__PURE__ */ (0, import_jsx_runtime41.jsx)("tbody", { children: dataRows.map((row, j) => /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(
                      "tr",
                      {
                        style: {
                          backgroundColor: j % 2 !== 0 ? "#f9fafb" : void 0
                        },
                        children: parseRow(row).map((cell, k) => /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(
                          "td",
                          {
                            style: {
                              border: "1px solid #e5e7eb",
                              padding: "0.5rem .5rem"
                            },
                            children: parseInline(cell)
                          },
                          k
                        ))
                      },
                      j
                    )) })
                  ]
                }
              )
            },
            key++
          )
        );
        continue;
      }
      if (line.startsWith(">")) {
        flushList();
        olStartCount = 0;
        const quoteLines = [];
        while (i < lines.length && lines[i].startsWith(">")) {
          quoteLines.push(lines[i].replace(/^>\s?/, ""));
          i++;
        }
        result.push(
          /* @__PURE__ */ (0, import_jsx_runtime41.jsx)("blockquote", { className: "Markup-blockquote", children: /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(Markup, { content: quoteLines.join("\n") }) }, key++)
        );
        continue;
      }
      if (line.startsWith("```")) {
        flushList();
        olStartCount = 0;
        const codeLines = [];
        i++;
        while (i < lines.length && !lines[i].startsWith("```")) {
          codeLines.push(lines[i]);
          i++;
        }
        result.push(
          /* @__PURE__ */ (0, import_jsx_runtime41.jsx)("pre", { className: "Markup-code-block", children: /* @__PURE__ */ (0, import_jsx_runtime41.jsx)("code", { children: codeLines.join("\n") }) }, key++)
        );
        i++;
        continue;
      }
      if (line.startsWith("### ")) {
        flushList();
        olStartCount = 0;
        result.push(
          /* @__PURE__ */ (0, import_jsx_runtime41.jsx)("h3", { className: "Markup-h3", children: parseInline(line.slice(4)) }, key++)
        );
      } else if (line.startsWith("## ")) {
        flushList();
        olStartCount = 0;
        result.push(
          /* @__PURE__ */ (0, import_jsx_runtime41.jsx)("h2", { className: "Markup-h2", children: parseInline(line.slice(3)) }, key++)
        );
      } else if (line.startsWith("# ")) {
        flushList();
        olStartCount = 0;
        result.push(
          /* @__PURE__ */ (0, import_jsx_runtime41.jsx)("h1", { className: "Markup-h1", children: parseInline(line.slice(2)) }, key++)
        );
      } else if (line.match(/^\s{0,3}-{3,}\s*$/)) {
        flushList();
        olStartCount = 0;
        result.push(/* @__PURE__ */ (0, import_jsx_runtime41.jsx)("hr", { className: "Markup-hr" }, key++));
      } else if (line.match(/^[-*] /)) {
        if (listType !== "ul") {
          flushList();
          listType = "ul";
        }
        listItems.push({ text: line.slice(2), subList: null });
      } else if (line.match(/^\d+\. /)) {
        if (listType !== "ol") {
          flushList();
          listType = "ol";
        }
        listItems.push({
          text: line.replace(/^\d+\. /, ""),
          subList: null
        });
      } else if (line.match(/^(?: {2,}|\t+)[-*] /) && listItems.length > 0) {
        const last = listItems[listItems.length - 1];
        if (!last.subList || last.subList.type !== "ul") {
          last.subList = { type: "ul", items: [] };
        }
        last.subList.items.push(line.replace(/^(?:\s+)[-*] /, ""));
      } else if (line.match(/^(?: {2,}|\t+)\d+\. /) && listItems.length > 0) {
        const last = listItems[listItems.length - 1];
        if (!last.subList || last.subList.type !== "ol") {
          last.subList = { type: "ol", items: [] };
        }
        last.subList.items.push(line.replace(/^(?:\s+)\d+\. /, ""));
      } else if (line.trim() === "") {
        flushList();
      } else {
        flushList();
        olStartCount = 0;
        result.push(
          /* @__PURE__ */ (0, import_jsx_runtime41.jsx)("p", { className: "Markup-p", children: parseInline(line) }, key++)
        );
      }
      i++;
    }
    flushList();
    return result;
  }, [content]);
  return /* @__PURE__ */ (0, import_jsx_runtime41.jsx)("div", { className: `Markup${className ? ` ${className}` : ""}`, children: blocks });
};
var Markup_default = Markup;

// src/components/EulaFormattedText/EulaFormattedText.tsx
var React19 = __toESM(require("react"));
var import_jsx_runtime42 = require("react/jsx-runtime");
var parseSegment = (text) => {
  const nodes = [];
  let last = 0;
  let key = 0;
  const combined = /\[([^\]]+)\]\(((?:https?:\/\/|www\.)[^)]+)\)/g;
  let match;
  while ((match = combined.exec(text)) !== null) {
    if (match.index > last) {
      nodes.push(
        /* @__PURE__ */ (0, import_jsx_runtime42.jsx)(React19.Fragment, { children: text.slice(last, match.index) }, key++)
      );
    }
    const href = match[2].startsWith("www.") ? `https://${match[2]}` : match[2];
    nodes.push(
      /* @__PURE__ */ (0, import_jsx_runtime42.jsx)(
        "a",
        {
          href,
          target: "_blank",
          rel: "noopener noreferrer",
          style: { color: "#0053CF", textDecoration: "underline" },
          children: match[1]
        },
        key++
      )
    );
    last = match.index + match[0].length;
  }
  if (last < text.length) {
    nodes.push(/* @__PURE__ */ (0, import_jsx_runtime42.jsx)(React19.Fragment, { children: text.slice(last) }, key++));
  }
  return nodes;
};
var EulaFormattedText = ({ content }) => {
  const nodes = [];
  let key = 0;
  const lines = content.split("\n");
  let i = 0;
  while (i < lines.length) {
    const line = lines[i];
    const trimmed = line.trim();
    if (trimmed.startsWith("***") && trimmed.endsWith("***")) {
      const inner = trimmed.slice(3, -3);
      nodes.push(
        /* @__PURE__ */ (0, import_jsx_runtime42.jsx)(
          "p",
          {
            style: {
              fontSize: "1.25rem",
              textAlign: "center",
              marginTop: "3rem",
              marginBottom: "0.5rem"
            },
            children: parseSegment(inner)
          },
          key++
        )
      );
    } else if (trimmed.startsWith("**") && trimmed.endsWith("**")) {
      const inner = trimmed.slice(2, -2);
      nodes.push(
        /* @__PURE__ */ (0, import_jsx_runtime42.jsx)(
          "p",
          {
            style: {
              fontWeight: "bold",
              marginTop: "1rem",
              marginBottom: "0.25rem"
            },
            children: parseSegment(inner)
          },
          key++
        )
      );
    } else if (trimmed.startsWith(">>")) {
      const inner = trimmed.slice(2).trim();
      nodes.push(
        /* @__PURE__ */ (0, import_jsx_runtime42.jsx)("p", { style: { marginBottom: "0.75rem", paddingLeft: "2rem" }, children: parseSegment(inner) }, key++)
      );
    } else if (trimmed === "") {
    } else {
      nodes.push(
        /* @__PURE__ */ (0, import_jsx_runtime42.jsx)("p", { style: { marginBottom: "0.75rem" }, children: parseSegment(trimmed) }, key++)
      );
    }
    i++;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime42.jsx)("div", { children: nodes });
};
var EulaFormattedText_default = EulaFormattedText;

// src/components/TableFilters/TableFilters.tsx
var import_react10 = require("@headlessui/react");
var import_react11 = require("react");
var import_hi9 = require("react-icons/hi");
var import_io5 = require("react-icons/io5");
var import_jsx_runtime43 = require("react/jsx-runtime");
var TableFilters = ({
  filters,
  disabled,
  activeFilters,
  clearFilters,
  onChange
}) => {
  const activeFilterCount = (0, import_react11.useMemo)(() => {
    return Object.values(activeFilters).reduce(
      (acc, curr) => acc + curr.length,
      0
    );
  }, [activeFilters]);
  return /* @__PURE__ */ (0, import_jsx_runtime43.jsxs)(import_react10.Popover, { className: "relative", children: [
    /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(import_react10.Popover.Button, { children: /* @__PURE__ */ (0, import_jsx_runtime43.jsxs)(
      Button_default,
      {
        variant: "secondary",
        size: "md",
        className: "flex flex-row items-center gap-1",
        disabled,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(
            import_io5.IoFilterOutline,
            {
              size: 16,
              className: disabled ? "text-gray-400" : "text-primary"
            }
          ),
          "Filter",
          activeFilterCount > 0 && ` (${activeFilterCount})`
        ]
      }
    ) }),
    /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(import_react10.Popover.Panel, { className: "absolute z-50 mt-3 rounded-lg border border-gray-200 bg-white pb-5 shadow", children: ({ close }) => /* @__PURE__ */ (0, import_jsx_runtime43.jsxs)("div", { className: "flex flex-col gap-5", children: [
      /* @__PURE__ */ (0, import_jsx_runtime43.jsxs)("div", { className: "flex flex-row items-center justify-between gap-3 px-7 pt-6", children: [
        /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(Typography_default, { variant: "body-xl", color: "primary", weight: "medium", children: "Filter" }),
        /* @__PURE__ */ (0, import_jsx_runtime43.jsx)("button", { onClick: () => close(), children: /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(import_hi9.HiX, { size: 24, className: "text-primary" }) })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime43.jsxs)("div", { className: "flex flex-col gap-2 px-7", children: [
        /* @__PURE__ */ (0, import_jsx_runtime43.jsx)("div", { className: "flex flex-col gap-5 whitespace-nowrap", children: filters.map((filter) => /* @__PURE__ */ (0, import_jsx_runtime43.jsxs)("div", { className: "flex flex-col gap-2", children: [
          /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(Typography_default, { variant: "body", color: "black", weight: "medium", children: filter.label }),
          /* @__PURE__ */ (0, import_jsx_runtime43.jsx)("div", { className: "pl-3", children: /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(
            CheckboxGroup_default,
            {
              name: filter.label,
              onChange: (e) => onChange == null ? void 0 : onChange(
                filter.key,
                e.target.value,
                e.target.checked
              ),
              children: filter.filters.map((option) => /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(
                Checkbox_default,
                {
                  label: option.label,
                  value: option.value,
                  checked: option.active
                },
                `${filter.label}-${option.value}`
              ))
            }
          ) })
        ] }, filter.label)) }),
        activeFilterCount > 0 ? /* @__PURE__ */ (0, import_jsx_runtime43.jsx)("div", { children: /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(
          "button",
          {
            onClick: () => {
              clearFilters();
              close();
            },
            children: /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(Typography_default, { variant: "body-sm", color: "link", children: "Clear Filters" })
          }
        ) }) : null
      ] })
    ] }) })
  ] });
};
var TableFilters_default = TableFilters;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Accordion,
  AdvisorTabs,
  AutoCloser,
  BackButton,
  Button,
  Checkbox,
  CheckboxGroup,
  DEFAULT_NO_SELECTION_ID,
  DatePicker,
  Dialog,
  Drawer,
  EulaFormattedText,
  ExclamationCircle,
  Icon,
  InputLabel,
  MGPIFrame,
  Markup,
  Radio,
  RadioGroup,
  SelectBox,
  Stepper,
  Table,
  TableFilters,
  Tabs,
  TextArea,
  TextInput,
  ToggleButton,
  Tooltip,
  Typography,
  formatCurrency,
  useIsSafari,
  useTabControls,
  useTableFilters
});
